import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'callback',
    pure: false,
    standalone: false
})
export class CallbackPipe implements PipeTransform {
    transform(items: any[], subId: any, callback: (item: any, subId: any) => boolean): any {
        if (!items || !callback) {
            return items;
        }
        return items.filter(item => callback(item, subId));
    }
}
